import { useEffect, useRef } from "react";
import { inject } from "../ng";

export function MapMousePosition() {
	const ref = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		const span = ref.current;
		if (!span) {
			return;
		}
		const map = inject("mapService").getMap();
		if (!map.div.isConnected) {
			return;
		}

		const prefix = "Lon: ";
		const separator = " Lat: ";
		const numDigits = 6;

		const position = new window.ALKMaps.Control.MousePosition({
			prefix,
			separator,
			numDigits,
			div: span,
		});

		const center = map
			.getCenter()
			.transform(
				new window.ALKMaps.Projection("EPSG:900913"),
				new window.ALKMaps.Projection("EPSG:4326"),
			);

		const lon = center.lon.toFixed(numDigits);
		const lat = center.lat.toFixed(numDigits);
		span.textContent = `${prefix}${lon}${separator}${lat}`;

		map.addControl(position);
		return () => {
			map.removeControl(position);
		};
	}, []);

	return <span ref={ref} />;
}
